// extracted by mini-css-extract-plugin
module.exports = {"main":"infodetails_main__wweqW"};